const Lightbulb = ({ color, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="30"
    viewBox="10 0 85 85"
    {...props}
  >
    {/* Gänga på lampan */}
    <rect
      x="40"
      y="67"
      width="20"
      height="4"
      fill="none"
      stroke="#F6A237"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <rect
      x="40"
      y="72"
      width="20"
      height="4"
      fill="none"
      stroke="#F6A237"
      strokeWidth="3"
      strokeLinecap="round"
    />

    {/* Sockel */}
    <rect
      x="42"
      y="76"
      width="16"
      height="7"
      fill="none"
      stroke="#F6A237"
      strokeWidth="3"
      rx="2"
    />

    {/* Ljuseffekt - streck runt lampan */}
    <line
      x1="18"
      y1="20"
      x2="25"
      y2="25"
      stroke={color || '#F6A237'}
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="82"
      y1="20"
      x2="75"
      y2="25"
      stroke={color || '#F6A237'}
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="69"
      y1="9"
      x2="65"
      y2="15"
      stroke={color || '#F6A237'}
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="50"
      y1="4"
      x2="50"
      y2="11"
      stroke={color || '#F6A237'}
      strokeWidth="4"
      strokeLinecap="round"
    />
    <line
      x1="31"
      y1="9"
      x2="35"
      y2="15"
      stroke={color || '#F6A237'}
      strokeWidth="4"
      strokeLinecap="round"
    />
    <path
      d="M 52 25 Q 65 27 67 41"
      fill="none"
      stroke="#F6A237"
      strokeWidth="4"
      strokeLinecap="round"
    />
    {/* Glödlampans glasdel (päronform) */}
    <circle
      cx="50"
      cy="42"
      r="24"
      fill="none"
      stroke="#F6A237"
      strokeWidth="4"
    />
  </svg>
)
export default Lightbulb
